import React from 'react';
import './OvoBullet.css';

export type OvoBulletProps = {
  text: string;
};

export function OvoBullet({ text }: OvoBulletProps) {
  return (
    <div>
      <span className={'ovoBullet'}></span>
      <span className={'sectionText'}>{text}</span>
    </div>
  );
}
